<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.fundpay_delete"
                           @click="handleDelete">删 除
                </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/v4ward/fundpay/fundpay";
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    searchShow: true,
                    searchMenuSpan: 6,
                    border: true,
                    index: true,
                    viewBtn: true,
                    selection: true,
                    dialogClickModal: false,
                    column: [
                                                                                    {
                                    label: "收费主表ID",
                                    prop: "id",
                                    rules: [{
                                        required: true,
                                        message: "请输入收费主表ID",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                                                                    {
                                    label: "小区id",
                                    prop: "communityId",
                                    rules: [{
                                        required: true,
                                        message: "请输入小区id",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "收费单号",
                                    prop: "paybillNo",
                                    rules: [{
                                        required: true,
                                        message: "请输入收费单号",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "收费人id",
                                    prop: "payManId",
                                    rules: [{
                                        required: true,
                                        message: "请输入收费人id",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "收费人姓名",
                                    prop: "payManName",
                                    rules: [{
                                        required: true,
                                        message: "请输入收费人姓名",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "支付方式",
                                    prop: "payType",
                                    rules: [{
                                        required: true,
                                        message: "请输入支付方式",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "理论总金额",
                                    prop: "totalCalAmount",
                                    rules: [{
                                        required: true,
                                        message: "请输入理论总金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "滞纳总金额",
                                    prop: "totalDelayAmount",
                                    rules: [{
                                        required: true,
                                        message: "请输入滞纳总金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "减免总金额",
                                    prop: "totalDerateAmount",
                                    rules: [{
                                        required: true,
                                        message: "请输入减免总金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "账户抵扣总金额",
                                    prop: "totalAccountpayAmount",
                                    rules: [{
                                        required: true,
                                        message: "请输入账户抵扣总金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "优惠券抵扣总金额",
                                    prop: "totalCouponAmount",
                                    rules: [{
                                        required: true,
                                        message: "请输入优惠券抵扣总金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "应收总金额",
                                    prop: "totalShouldAmount",
                                    rules: [{
                                        required: true,
                                        message: "请输入应收总金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "实收总金额",
                                    prop: "totalPayAmount",
                                    rules: [{
                                        required: true,
                                        message: "请输入实收总金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "收银员",
                                    prop: "cashier",
                                    rules: [{
                                        required: true,
                                        message: "请输入收银员",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "付款时间",
                                    prop: "payTime",
                                    rules: [{
                                        required: true,
                                        message: "请输入付款时间",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "渠道订单号",
                                    prop: "channelOrderNo",
                                    rules: [{
                                        required: true,
                                        message: "请输入渠道订单号",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "收费状态（系统字典 fund_pay_status 0.待收费，1.收费成功，2.收费失败，3.已退款，4.已关闭）",
                                    prop: "payStatus",
                                    rules: [{
                                        required: true,
                                        message: "请输入收费状态（系统字典 fund_pay_status 0.待收费，1.收费成功，2.收费失败，3.已退款，4.已关闭）",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "收费描述（用于渠道返回）",
                                    prop: "payRemark",
                                    rules: [{
                                        required: true,
                                        message: "请输入收费描述（用于渠道返回）",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "票据号",
                                    prop: "invoiceNo",
                                    rules: [{
                                        required: true,
                                        message: "请输入票据号",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "收费来源，参考数据字典pay_cost",
                                    prop: "payCost",
                                    rules: [{
                                        required: true,
                                        message: "请输入收费来源，参考数据字典pay_cost",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "收费备注（用于业务展示）",
                                    prop: "description",
                                    rules: [{
                                        required: true,
                                        message: "请输入收费备注（用于业务展示）",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "打印次数",
                                    prop: "printTimes",
                                    rules: [{
                                        required: true,
                                        message: "请输入打印次数",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "最后打印人",
                                    prop: "lastPrintMan",
                                    rules: [{
                                        required: true,
                                        message: "请输入最后打印人",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "最后打印时间",
                                    prop: "printTime",
                                    rules: [{
                                        required: true,
                                        message: "请输入最后打印时间",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "打印摘要",
                                    prop: "printRemark",
                                    rules: [{
                                        required: true,
                                        message: "请输入打印摘要",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "发票开票状态（0.未开票，1.已开票)",
                                    prop: "invoicingFlag",
                                    rules: [{
                                        required: true,
                                        message: "请输入发票开票状态（0.未开票，1.已开票)",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "发票id",
                                    prop: "invoiceId",
                                    rules: [{
                                        required: true,
                                        message: "请输入发票id",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "备注",
                                    prop: "remark",
                                    rules: [{
                                        required: true,
                                        message: "请输入备注",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "版本",
                                    prop: "version",
                                    rules: [{
                                        required: true,
                                        message: "请输入版本",
                                        trigger: "change"
                                    }]
                                },
                                                                        ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.fundpay_add, false),
                    viewBtn: this.vaildData(this.permission.fundpay_view, false),
                    delBtn: this.vaildData(this.permission.fundpay_delete, false),
                    editBtn: this.vaildData(this.permission.fundpay_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
            rowSave(row, done, loading) {
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>
</style>
